<now-wbsuche-lib-facetten-modal-button [modalId]="modalId" [searchable]="searchable">
</now-wbsuche-lib-facetten-modal-button>

@if (searchable) {
  <div class="position-relative">
    <i aria-hidden="true" class="now-icon now-icon-magnifying-glass"></i>
    <input
      type="text"
      [placeholder]="label + ' suchen'"
      [(ngModel)]="filterSuchwort"
      class="form-control darker-placeholder search-input"
    />
    @if (this.filterSuchwort !== '') {
      <button
        [id]="komponentenId + '_clear_button'"
        type="button"
        (click)="clearFilter()"
        class="clean-btn now-icon-x now-btn-icon-only"
        [attr.aria-label]="label + ' Filter löschen'"
      ></button>
    }
  </div>
}

@if (selectedItemBtnVisible$ | async) {
  <button
    (click)="scrollToFirstItem()"
    class="buttonAsLink w-100 mb-1"
    id="{{ komponentenId }}_facette_zu_ausgewaehlten_item_springen_btn"
  >
    {{ countOfSelectedItems }}
    {{ countOfSelectedItems > 1 ? 'ausgewählte' : 'ausgewählten' }} {{ label }} anzeigen
    <span class="now-icon now-icon-arrow-up"></span>
  </button>
}

<now-wbsuche-lib-checkbox-liste
  #checkboxList
  [komponentenId]="komponentenId"
  (checkboxClicked)="onItemSelected($event)"
  [filterList]="searchable ? filteredSelectItems : sortedSelectItems"
  [searchable]="searchable"
  [pinSelectedAtTop]="pinSelectedAtTop"
  [label]="label"
  [maxHeight]="maxHeight"
  [forceTextWrap]="forceTextWrap"
  [ngClass]="
    (selectedItemBtnVisible$ | async) ? 'scrollbar limitHeightSmall' : 'scrollbar limitHeightBig'
  "
  (selectedItemVisible)="onSelectedItemVisible($event)"
></now-wbsuche-lib-checkbox-liste>
